module.exports = __webpack_public_path__ + "icon-alertminer-service.f4c7054c6a52320ca62b.png";